import { useEffect, useRef } from 'react'
import { useReactiveVar } from '@apollo/client'
import { walletSignatureVar, wizardStepVar } from '../store/wizard.store'
import { WizardStep } from '../types'
import { useVerifyWallet } from './use-verify-wallet'

export function useVerifyWalletOnDoneStep() {
  const { verifyWallet, loading } = useVerifyWallet()
  const wizardStep = useReactiveVar(wizardStepVar)
  const walletSignature = useReactiveVar(walletSignatureVar)
  const verifiedSignatureRef = useRef<string | null>(null)

  useEffect(() => {
    if (wizardStep !== WizardStep.done || !walletSignature) {
      if (wizardStep !== WizardStep.done) verifiedSignatureRef.current = null
      return
    }
    if (verifiedSignatureRef.current === walletSignature) return

    verifiedSignatureRef.current = walletSignature
    void verifyWallet()
  }, [verifyWallet, wizardStep, walletSignature])

  return { loading }
}
